import 'ol/ol.css';
import { Vector as VectorLayer, Heatmap as HeatmapLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Circle as CircleStyle, Icon, Fill, Stroke } from 'ol/style';
import GeoJSON from "ol/format/GeoJSON";
import Point from "ol/geom/Point";
import { interpolateColors, runAnimationFeature, setMapSingleEventHandler, setSourceForGeoJSON } from 'map/OlExtension'
import { getVectorContext } from 'ol/render';
import { unByKey } from 'ol/Observable';
import { getRandomIntInclusive, hexToRgba, settingsConfig } from 'utils/commonFunc';
import defColors from 'utils/defColors';
import ApiService from 'services/ApiService';
import { ToFeatures } from 'services/GeoJsonService';
import { toLonLat, fromLonLat } from 'ol/proj';
import { Feature } from 'ol';

const heatmapSource = new VectorSource();

export default class LayerBusHeatGetOff extends HeatmapLayer {
    constructor(map) {
        super({
            source: heatmapSource,
            name: 'busHeatLayerGetOff',
            userLayer: true,
            layerIndex: 2,
            blur: 50,
            radius: 32,
            weight: function (feature) {
                if(!feature) {
                    
                }
                return feature.get('weight');
            },
            visible: false,
        });
        this.map = map;        
        this.map?.addLayer(this);
        this._isDataLoaded = false;
    }

    setHeatData = function (dateStr) {
        const layer = this;
        layer._isDataLoaded = false;      
        const sdtm = dateStr + "00";
        const edtm = dateStr + "23";
        const url = "newdashboard/busoprt/GetBusPssngrHitMapData?sdtm="+sdtm+"&edtm="+edtm;
        ApiService.get(url).then(response => {
            if (response.status === 200) {
                const data = response.data;                        
                layer.pssngr = data.pssngr;
                
                if(layer.pssngr['00']) {
                    
                    let list = layer.pssngr['00'];
                    list.sort((a, b) => a.outCnt - b.outCnt);
                    const maxCnt = list[list.length - 1].outCnt;

                    for(let i = 0; i < list.length; i++) {

                        let id = list[i]['stationId'];
                        let hh = list[i]['hh'];
                        let x = list[i]['x'];
                        let y = list[i]['y'];
                        let outCnt = list[i]['outCnt'];
                        // let weight = outCnt / maxCnt;
                        let weight = outCnt < 50 ? 0.1 : (outCnt < 100 ? 0.25 : (outCnt < 150 ? 0.5 : (outCnt < 200 ? 0.75 : 1)))
                        
                        const feature = new Feature({
                            geometry: new Point(fromLonLat([x, y])),
                            weight: weight
                        });
                        heatmapSource.addFeature(feature); 
                    }
                    layer._isDataLoaded = true;
                }
            }
        })
    }

    changeTime = function (timeStr) {
        const layer = this;
        layer._isDataLoaded = false;
        if(layer.pssngr) {
            if(layer.pssngr[timeStr]) {
                
                let list = layer.pssngr[timeStr];
                list.sort((a, b) => a.outCnt - b.outCnt);
                const maxCnt = list[list.length - 1].outCnt;

                heatmapSource.clear(true);
                for(let i = 0; i < list.length; i++) {

                    let id = list[i]['stationId'];
                    let x = list[i]['x'];
                    let y = list[i]['y'];
                    let outCnt = list[i]['outCnt'];
                    // let weight = outCnt / maxCnt;
                    let weight = outCnt < 50 ? 0.1 : (outCnt < 100 ? 0.25 : (outCnt < 150 ? 0.5 : (outCnt < 200 ? 0.75 : 1)))
                    
                    const feature = new Feature({
                        geometry: new Point(fromLonLat([x, y])),
                        weight: weight
                    });
                    heatmapSource.addFeature(feature);
                }
                layer._isDataLoaded = true;
            }
        }
    }
}